<div #dropdown="ngbDropdown" ngbDropdown [container]="isBody ? 'body' : null" class="dropdown-group text-dark h-100">
	<div
		ngbDropdownAnchor
		#labelField
		[class.p-0]="dropdown.isOpen()"
		class="form-control dropdown-input position-relative border-0 w-100 h-100 d-flex align-items-center justify-content-between"
		[ngClass]="disabled ? 'bg-gray-200 no-pointer' : 'cursor-pointer bg-white'">
		@if (!dropdown.isOpen()) {
			<div class="one-line text-dark d-block">
				{{ title }}
				@if (!title || title === '') {
					<span class="text-muted">{{ placeholder }}</span>
				}
			</div>
		}
		@if (dropdown.isOpen()) {
			<input
				type="text"
				autocomplete="off"
				class="form-control form-input"
				name="searchInputField"
				(keyup)="changeValue($event)"
				(keypress)="enterPress($event)"
				(blur)="resetData()"
				[(ngModel)]="title"
				(ngModelChange)="search($event)" />
		}
		@if (!dropdown.isOpen()) {
			<img alt="toggle" class="dropdown-img" loading="lazy" src="assets/orca/catalogTree/arrow_down.svg" />
		}
		<div
			class="dropdown-menu overflow-auto"
			[style.width.px]="labelField.clientWidth"
			[class.d-none]="disabled"
			ngbDropdownMenu
			[style.height]="dropdownHeight"
			[style.minHeight.rem]="minHeightDropdown"
			[style.maxHeight]="maxDropdownHeight"
			aria-labelledby="dropdownBox">
			@for (option of searchlist; track option; let idx = $index) {
				<button
					[ngClass]="model === option.value ? 'bg-primary' : ''"
					tabindex="-1"
					(mousedown)="$event.preventDefault()"
					(click)="$event.preventDefault()"
					(mouseup)="$event.preventDefault(); valueChange(option)"
					class="p-2 dropdown-item d-flex align-items-center text-dark dropdown-item-{{ idx }}">
					<span class="d-block one-line" [innerHtml]="option.key | searchhighlight: searchterm"> </span>
					@if (infoDescription) {
						<span class="text-muted">&nbsp;&nbsp; |&nbsp;&nbsp; {{ infoDescription }}: </span>
					}
					@if (option.additionalValue) {
						<span class="text-muted" [innerHtml]="option.additionalValue | searchhighlight: searchterm"></span>
					}
				</button>
			}
		</div>
	</div>
</div>
